import React from "react";
import i18next from "src/i18n/config";
import semverService from "src/services/semverService/semverService";

import { BuildEvents, EventReport } from "@dashboard/devices/types";
import { TextLink } from "@shared/TextLink";

import type { EventContext } from "./eventTypes";

export const getActorTitle = (event: EventReport): string | undefined => {
    return event.actorTitle && event.actorTypeName !== "Anonymous" ? event.actorTitle : undefined;
};

export const createLicenseLink = (event: EventReport, context: EventContext): React.ReactElement => {
    const { license, handleLicenseClick } = context;
    if (license && handleLicenseClick) {
        return (
            <TextLink onClick={() => handleLicenseClick(event)} tooltip={i18next.t("modals:eventModals.tooltip.showThisLicense")} />
        );
    }
    return <span />;
};

export const createDeviceLink = (event: EventReport, context: EventContext): React.ReactElement => {
    const { device, handleDeviceNameClick } = context;
    if (device && handleDeviceNameClick) {
        return (
            <TextLink onClick={() => handleDeviceNameClick(event)} tooltip={i18next.t("modals:eventModals.tooltip.showThisDevice")} />
        );
    }
    return <span />;
};

export const createGroupLink = (event: EventReport, context: EventContext): React.ReactElement => {
    const { group, handleGroupNameClick } = context;
    if (group && handleGroupNameClick) {
        return (
            <TextLink onClick={() => handleGroupNameClick(event)} tooltip={i18next.t("modals:eventModals.tooltip.showThisGroup")} />
        );
    }
    return <span />;
};

export const createProductBuildLink = (event: BuildEvents, context: EventContext): React.ReactElement => {
    const { navigate, products, builds } = context;

    const majorAndroidVersion = semverService.getMajorVersion(event.data?.version)?.toString();
    const product = products?.find((p) => p.codename === event.data?.codename && p.androidVersion === majorAndroidVersion);
    const buildExists = builds?.some((b) => b.productId === product?.id && b.version === event.data?.version);

    if (navigate && product && buildExists) {
        return (
            <TextLink
                tooltip={i18next.t("modals:eventModals.tooltip.showThisProduct")}
                onClick={() => navigate(`/dashboard/products/${product.codename}/${product.androidVersion}`)}
            />
        );
    }
    return <span />;
};
